import { z } from "zod"
import { CreateGroupRoleDtoSchema } from "@mimber/schema"

/**
 * Form schema for creating a group role
 */
export const createGroupRoleSchema = CreateGroupRoleDtoSchema.extend({
  description: z
    .string()
    .max(1000, "Description must be less than 1000 characters")
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

/**
 * Output type - this is what gets passed to onSubmit
 */
export type CreateGroupRoleData = z.output<typeof createGroupRoleSchema>
